import React, { memo } from "react";

const PrimaryButton = memo(
  ({ text, callback, disabled = false, className, href }) => {
    return (
      <>
        {href ? (
          <a
            href={href}
            target={"_blank"}
			rel="noreferrer"
            className={className}
          >
            {text}
          </a>
        ) : (
          <button
            disabled={disabled}
            onClick={callback}
            className={className}
          >
            {text}
          </button>
        )}
      </>
    );
  }
);

export default PrimaryButton;
